import 'css-chunksrc/client/scenes/planzoneVirtualResourceAddition/virtualResourceForm/roleSelection/styles.scss';export default {
  "roleSelection": "_roleSelection_1q2pa_1",
  "input": "_input_1q2pa_5",
  "selection": "_selection_1q2pa_18",
  "placeholder": "_placeholder_1q2pa_24",
  "list": "_list_1q2pa_28",
  "role": "_role_1q2pa_1",
  "iconBox": "_iconBox_1q2pa_55",
  "icon": "_icon_1q2pa_55",
  "opened": "_opened_1q2pa_65",
  "selectedRole": "_selectedRole_1q2pa_73",
  "selectedRoleIcon": "_selectedRoleIcon_1q2pa_77",
  "selectedRoleTitle": "_selectedRoleTitle_1q2pa_83",
  "roleDescription": "_roleDescription_1q2pa_90"
};